import memoize from '@framework/data-helpers/memoize';
import keyResolver from '@framework/data-helpers/keyResolver';
import { SEPARATOR } from '@/creditflowresearch/application/SearchHeaderMenu/constants';
import { HeaderMappingItem } from '@/creditflowresearch/application/actions/profile/helpers/types';

export interface ICheckModuleVisibilityParams {
  mapping: Record<string, HeaderMappingItem> | null | undefined,
  productIds: string[],
  regionIds: string[],
  moduleName: string,
}

export const checkModuleVisibility = (params: ICheckModuleVisibilityParams): boolean => {
  const { mapping, productIds, regionIds, moduleName } = params;

  if (!mapping || !productIds.length || !regionIds.length) {
    return false;
  }

  return isModuleVisibleMemoized(mapping, productIds, regionIds, moduleName);
};

const isModuleVisibleMemoized = memoize(
  (
    mapping: Record<string, HeaderMappingItem>,
    selectedProducts: string[],
    selectedRegions: string[],
    moduleName: string,
  ): boolean => {
    const pairs: string[] = [];
    selectedProducts.forEach((productId) => {
      selectedRegions.forEach((regionId) => {
        pairs.push(`${ productId }${ SEPARATOR }${ regionId }`);
      });
    });

    return pairs.some((currentPair) => mapping[currentPair]?.[moduleName] === true);
  },
  keyResolver,
);
